@if (this.defect.id > 0 && this.defect.source === 'walkaround') {
  <div class='sourceBadge'>
    <i class="fas fa-mobile-alt"></i> Auto-raised from a driver walkaround check
  </div>
}

<div class="form-row">
  <div class="form-group col-md-4">
    <label>Vehicle</label>
    <ng-select [(ngModel)]="this.defect.vehicleId" class='form-control' [class.is-invalid]='this.defect.vehicleId === -1'
      (change)='this.defect.vehicleId = +$event; this.defect.vehicle.id = this.defect.vehicleId'>
      @for (item of this.vehicles; track item) {
        <ng-option [value]='item.id'>{{ item.registration }}</ng-option>
      }
    </ng-select>
  </div>
  <div class="form-group col-md-4">
    <label>Check Area</label>
    <ng-select [(ngModel)]="this.defect.vehicleCheckAreaId" class='form-control'
      (change)='this.defect.vehicleCheckAreaId = +$event'>
      @for (item of this.checkAreas; track item) {
        <ng-option [value]='item.id'>{{ item.name }}</ng-option>
      }
    </ng-select>
  </div>
  <div class="form-group col-md-4">
    <label>Severity</label>
    <ng-select [(ngModel)]="this.defect.severityId" class='form-control' [class.is-invalid]='this.defect.severityId === -1'
      (change)='this.defect.severityId = +$event'>
      @for (item of this.severities; track item) {
        <ng-option [value]='item.id'>{{ item.notes }}</ng-option>
      }
    </ng-select>
  </div>
</div>

<div class='form-row'>
  <div class="form-group col-md-12">
    <label>Description</label>
    <textarea name='description' [(ngModel)]='this.defect.description' [class.is-invalid]='!this.defect.description' class="form-control" rows="3"></textarea>
  </div>
</div>

<div class='form-row'>
  <div class="form-group col-md-4">
    <label>Status</label>
    <ng-select [(ngModel)]="this.defect.status" class='form-control'>
      @for (item of this.statuses; track item) {
        <ng-option [value]='item.id'>{{ item.label }}</ng-option>
      }
    </ng-select>
  </div>
</div>

<div class='form-row'>
  <div class="form-group col-md-12">
    <label>Notes <small class='text-muted'>(optional)</small></label>
    <textarea name='notes' [(ngModel)]='this.defect.notes' class="form-control" rows="2"></textarea>
  </div>
</div>
